import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraFields: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.jira-fields',
		defaultMessage: 'Jira fields',
		description: 'Jira Fields heading',
	},
	includeInImport: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.include-in-import',
		defaultMessage: 'Include in import',
		description: 'Include in import heading',
	},
	emptyViewMessage: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.empty-view-message',
		defaultMessage: 'No fields found',
		description: 'Empty view message',
	},
});
